import React, { Component } from "react";
import { connect } from "react-redux";

import instance from "../../axios";
import pieChartDefault from "../../Components/common/Charts/pieChartDefault";
import moment from "moment";
import Skeleton from "@mui/material/Skeleton";
import axios from 'axios'
import { addTab10, addTab11, addTab13, addTab14, addTab1,addTab2,addTab3,addTab4,addTab5,addTab6,addTab7, addTab8, addTab9, addTab15 , addTab18, addTab17, addTab19} from "../../Actions/MaintDashboard";
import 'react-toastify/dist/ReactToastify.css';
import withRoutes from "../../HOC/HocRoutes";
import MaintenanceDashboardView from "./MaintenanceDashboardView";

const CancelToken = axios.CancelToken
let source
export const FiltersOption = [
  { label: "MTD", value: 1 },
  { label: "Last Month", value: 2 },
  { label: "Last 3 months", value: 3 },
  { label: "YTD", value: 4 },
  { label: "Last Year", value: 5 },
  { label: "ALL", value: 6 },
];

export const FiltersOptionWithoutMTD = [
  { label: "Last Month", value: 2 },
  { label: "Last 3 months", value: 3 },
  { label: "YTD", value: 4 },
  { label: "Last Year", value: 5 },
  { label: "ALL", value: 6 },
];

export const MaintenanceItemEmpty = React.memo(() => {
  return (
    <div className={"mainten-section mainten"}>
      <div className="mainten-section-header">
        <span style={{ display: "flex", justifyContent: "space-between" }}>
          <Skeleton className="skeleton-pulse" width={150} height={25} />{" "}
          {/* </span>
        <span> */}
          <Skeleton className="skeleton-pulse" width={150} height={25} />{" "}
        </span>
      </div>

      <div className="mainten-section-body">
        <div className="mainten-split-section">
          <div>
            <Skeleton className="skeleton-pulse" width={"100%"} height={25} />
          </div>
          <div>
            <Skeleton className="skeleton-pulse" width={"100%"} height={25} />{" "}
          </div>
          <div>
            <Skeleton className="skeleton-pulse" width={"100%"} height={25} />{" "}
          </div>{" "}
          <div>
            <Skeleton className="skeleton-pulse" width={"100%"} height={25} />{" "}
          </div>
        </div>
        {/* <div>
          <span style={{ display: "flex", justifyContent: "space-around" }}>
            <Skeleton className="skeleton-pulse" width={150} height={35} />
            <Skeleton className="skeleton-pulse" width={150} height={35} />
          </span>
        </div>
        <div>
          <span style={{ display: "flex", justifyContent: "space-around" }}>
            <Skeleton className="skeleton-pulse" width={150} height={35} />
            <Skeleton className="skeleton-pulse" width={150} height={35} />
          </span>
        </div> */}
      </div>
    </div>
  );
});
class MaintenanceDashbd extends Component {
  constructor() {
    super();
    this.state = {
      totalCost: 1,
      totalOutStanding: "",
      vehicleCategories: "",
      maintRequest: "",
      maintRequestCategory: "",
      packageAccount: "",
      usedPart: "",
      usedService: "",
      usedPackages: "",
      vehicleCategoryCost: "",
      topVehicleModelCost: "",
      salesClients: {},
      salesClients1: {},
      salesClientsWise: {},
      salesClientsTab1: {},
      clientVehiclesVehicleWise: [],
      maintRequestClientWise: {},
      maintRequestClientWiseTab1: {},
      maintenanceRequestCount: {},
      collectionsAndOutStanding: {},
      salesDataMonthly: [],
      salesDataYearly: [],
      vehiclesCategories: [],
      totalProfitTab14: [],
      partsMaintRequest: 0,
      serviceMaintRequest: 0,
      packageMaintRequest: 0,
      monthlySaleNetAmount: {},
      topVehiles:[],
      topMaintenancePerDay:{},
      topMaintenancePerKm:{},
      cogs: [],
      tab1: "ALL",
      tab2: "ALL",
      tab3: "ALL",
      tab4: "ALL",
      tab5: "ALL",
      tab6: "ALL",
      tab7: "ALL",
      tab8: "ALL",
      tab9: "ALL",
      tab10: "ALL",
      tab11: "ALL",
      tab12: "ALL",
      tab13: "ALL",
      tab14: "ALL",
      tab15: "MTD",
      totalOurDue: 0,
      totalAccounts: "",
      selectedVehicle: {},
      openGraph: false,
      loader: false,
      loader1: false,
      loader2: false,
      loader3: false,
      loader4: false,
      loader5: false,
      loader6: false,
      loader7: false,
      loader8: false,
      loader9: false,
      loader10: false,
      loader11: false,
      loader12: false,
      loader13: false,
      loader14: false,
      loader15: false,
      loaderA1: false,
      loaderA2: false,
      loaderA3: false,
      tab1loader1:false,
      tab1loader2:false,
      tab1loader3:false,
      tab1loader4:false,
      tab1loader5:false,
      loader18: false,
      loader17: false,
      loader19: false,
      xs: window.innerWidth <= 600,
      sm: window.innerWidth < 960,
    };
    window.addEventListener('resize', this.handleResize);
  }

  componentWillMount() {
    let  timezone = "";
    if (
      this.props.logInUser &&
      this.props.logInUser.attributes &&
      this.props.logInUser.attributes.timezone
    ) {
      timezone = this.props.logInUser.attributes.timezone
    }else{
      timezone = "Asia/Riyadh"
    }
      const now = moment().tz(timezone);

      // ======== this part is for dashboards/cms/16, stations part, start of year YTD=========

      const startOfYear = now.clone().startOf("year");
      const endOfDay = now.clone().endOf("day");

      // ======== this part is for dashboards/cms/16, stations part, start of month MTD=========

      const startOfMonth = now.clone().startOf("month");
      const endOfMonth = now.clone().endOf("month");

      // ===================================================================

      const lastYearStart = startOfYear.clone().subtract(1, "year");
      const lastYearEnd = endOfDay.clone().subtract(1, "year");
      // ===================================================================
     

    this.getDashboardData(startOfYear.toISOString(),endOfDay.toISOString(), startOfMonth.toISOString() , endOfMonth.toISOString(), lastYearStart.toISOString(), lastYearEnd.toISOString());
  }
  componentWillUnmount() {
    source = CancelToken.source()
 }
 componentWillUnmount() {
  window.removeEventListener('resize', this.handleResize);
}

handleResize = () => {
  this.setState({
    xs: window.innerWidth <= 600, 
    sm: window.innerWidth < 960,
  });
};

  getDashboardData = (from, to,startOfMonth , endOfMonth,  lastYearStart ,  lastYearEnd) => {
    let tab1Data ={}
    // this.getCMS16(endOfMonth,startOfMonth, true); // this is for dashboards/cms/16,   stations part,
    this.getCMS16(true); // this is for dashboards/cms/16,   stations part,
    this.setState({ loaderA1: true , tab1loader3:true}, () => {
      if(this.props.tab1 && this.props.tab1.initFetch){
        this.setState({
          // totalCost:this.props.tab1.totalCost,
          initFetch:true,
          loaderA1:false,
          loader1:false,
          tab1loader3:false
        })
      }
      else{
        // instance({ url: `/api/dashboards/fmd/1?to=${to}&from=${from}`, method: "GET" })
        //   .then((res) => {
        //     this.setState({ totalCost: res, loaderA1: false ,  tab1loader3:false});
        //     tab1Data={
        //       ...tab1Data,
        //       totalCost:res,
        //       initFetch:true,
             
        //     }
        //     this.props.dispatch(addTab1(tab1Data))
        //   })
        //   .catch((err) => {});
          
        }
      });
      this.setState({ loader10: true, tab1loader2:true }, () => {
        if(this.props.tab1 && this.props.tab1.initFetch){
          this.setState({
            // totalCost:this.props.tab1.totalCost,
            totalAccounts:this.props.tab1.totalAccounts,
            initFetch:true,
            loaderA1:false,
            loader1:false,
            tab1loader2:false
          })
        }
        else{
          // instance({ url: `/api/dashboards/cms/14?to=${lastYearEnd}&from=${lastYearStart}`, method: "GET" })
          instance({ url: `/api/dashboards/cms/14?contractType=1&userType=3`, method: "GET" })
            .then((res) => {
              this.setState({ totalAccounts: res,  tab1loader2:false });
              tab1Data={
                ...tab1Data,
                totalAccounts:res,
                initFetch:true,
              

              }
              this.props.dispatch(addTab1(tab1Data))
  
            })
            .catch((err) => {
              // console.log("err 1====", err)
            });
        }
        })


    this.setState({ loader5: true }, () => {
      if(this.props.tab6 && this.props.tab6.initFetch){
        this.setState({
          loader5: false,
          totalFleetSize : this.props.tab6.totalFleetSize || 0,
          clientVehiclesVehicleWise: this.props.tab6.clientVehiclesVehicleWise || [],
        });
      }
      else{
        instance({ url: `/api/dashboards/cms/2?contractType=1&userType=3`, method: "GET" })
          .then((res) => {

            let makeData = [];
            let colors = [
              "#da5e5e",
              "#f50057",
              "#7b101b",
              "#00c179",
              "#d52f2f",
              "#ec1c91",
              "#28a788",
              "#3f52b5e6",
              "#594a86",
              "#864a73",
            ];
            let maxUsedCount = Math.max(
              ...res.data.map((item) => item.accessVehiclesCount)
            );
            let dtRes = res.data.reverse();
            let usedPartPercentages = dtRes.map((item) => {
              return {
                ...item,
                salesPercentage: (item.accessVehiclesCount / maxUsedCount) * 100,
              };
            });
            this.setState({
              loader5: false,
              totalFleetSize : res.totalFleetCount,
              clientVehiclesVehicleWise: usedPartPercentages,
            });
            let dt = {
              initFetch:true,
              totalFleetSize : res.totalFleetCount,
              clientVehiclesVehicleWise:usedPartPercentages
            }
             this.props.dispatch(addTab6(dt))
          })
          .catch((err) => {});

      }
    });

    this.setState({ loader7: true , tab1loader1:true}, () => {
      // cancelToken: source.token,
      if(this.props.tab8 && this.props.tab8.initFetch){
         this.setState({
          loader7: false,
          tab1loader1:false,
          maintRequestClientWise: {
            clientList: this.props.tab8.maintRequestClientWise.clientList,
            totalInvoicesCount: this.props.tab8.maintRequestClientWise?.totalInvoicesCount || 0,
          },
          maintRequestClientWiseTab1: this.props.tab8.maintRequestClientWiseTab1 || 1,
        });
      }
      else{
        instance({ url: `/api/dashboards/cms/3?contractType=1&userType=3`, method: "GET" })
        .then((res) => {
          let maxUsedCount = Math.max(
            ...res.clientList.map((item) => item.count)
          );
          let usedPartPercentages =
            res.clientList &&
            res.clientList.map((item) => {
              return {
                ...item,
                countPercentage: (item.count / maxUsedCount) * 100,
              };
            });


          this.setState({
            loader7: false,
            tab1loader1:false,
            maintRequestClientWise: {
              clientList: usedPartPercentages,
              totalInvoicesCount: res?.totalInvoicesCount || 0,
            },
            maintRequestClientWiseTab1: res?.totalDeliveryNotesCount || 1,
          });
          let dat = {
            initFetch:true,
            maintRequestClientWise: {
              clientList: usedPartPercentages,
              totalInvoicesCount: res?.totalInvoicesCount || 0,
            },
            maintRequestClientWiseTab1: res?.totalDeliveryNotesCount || 1,
          }
          this.props.dispatch(addTab8(dat)); 

        })
        .catch((err) => {
          console.log("err 3 ====", err);
        });
      }
    });

    this.setState({ loader4: true , tab1loader5:true}, () => {
      if(this.props.tab5 && this.props.tab5.initFetch){
        let res = this.props.tab5.res || {}
         let maxUsedCount = Math.max(
          ...res.clientList.map((item) => item.saleNetAmount)
        );
        let usedPartPercentages = res.clientList.map((item) => {
          return {
            ...item,
            salesPercentage: (item.saleNetAmount / maxUsedCount) * 100,
          };
        });
        this.setState({
          loader4: false,
          tab1loader5:false,
          salesClientsTab1: res?.totalSaleTotalAmount || 0,
          salesClients: {
            ...res,
            clientList: usedPartPercentages,
          },
          salesClients1: {
            ...res,
            clientList: usedPartPercentages,
          },
        })
      }
      else{
          instance({ url: `/api/dashboards/cms/4?contractType=1&userType=3`, method: "GET" })
            .then((res) => {
              let maxUsedCount = Math.max(
                ...res.clientList.map((item) => item.saleNetAmount)
              );
              let usedPartPercentages = res.clientList.map((item) => {
                return {
                  ...item,
                  salesPercentage: (item.saleNetAmount / maxUsedCount) * 100,
                };
              });
              this.setState({
                loader4: false,
                tab1loader5:false,

                salesClientsTab1: res?.totalSaleTotalAmount || 0,
                salesClients: {
                  ...res,
                  clientList: usedPartPercentages,
                },
                salesClients1: {
                  ...res,
                  clientList: usedPartPercentages,
                },
              });
              let dat ={
                res:res,
                initFetch:true
              }
              this.props.dispatch(addTab5(dat)); 
            })
            .catch((err) => {})

      }
    })

    this.setState({ loader6: true, tab1loader4:true  }, () => {
      if(this.props.tab7 && this.props.tab7.initFetch){
         this.setState({
          loader6: false,
          tab1loader4:false,
          salesClientsWise: {
            ...this.props.tab7.salesClientsWise,
            clientList: this.props.tab7.salesClientsWise.clientList,
          },
          totalOurDue: this.props.tab7?.totalOurDue || 0,
        });
      }
      else{
        instance({ url: `/api/dashboards/cms/5?contractType=1&userType=3`, method: "GET" })
          .then((res1) => {
            let res = res1.clientList.reverse();
             let maxUsedCount = Math.max(
              ...res.map((item) => item.overDue)
            );
            let usedPartPercentages = res.map((item) => {
              return {
                ...item,
                ourDuePercentage:
                  (item.overDue / maxUsedCount) * 100,
              };
            });
  
            this.setState({
              loader6: false,
              tab1loader4:false,

              salesClientsWise: {
                ...res1,
                clientList: usedPartPercentages,
              },
              totalOurDue: res1?.totalOurDue || 0,
            });
            let dt = {
              initFetch:true,
              salesClientsWise: {
                ...res1,
                clientList: usedPartPercentages,
              },
              totalOurDue: res1?.totalOurDue || 0,
            }
            this.props.dispatch(addTab7(dt))
          })
          .catch((err) => {
            console.log("err 5====", err);
          });
      }
    });

    this.setState({ loader2: true }, () => {
      if(this.props.tab2 && this.props.tab2.initFetch){
         this.setState({
          loader2: false,
          maintenanceRequestCount: this.props.tab2?.maintenanceRequestCount|| {},
          partsMaintRequest: this.props.tab2?.partsMaintRequest || {},
          serviceMaintRequest: this.props.tab2?.serviceMaintRequest || {},
          packageMaintRequest: this.props.tab2?.packageMaintRequest || {}
        });
      }
      else{
        instance({ url: `/api/dashboards/cms/6?contractType=1&userType=3`, method: "GET" })
          .then((res) => {
            let dt = [];
            for (const [key, value] of Object.entries(res)) {
              dt.push({ name: key, value: value });
            }
            let maxUsedCount = Math.max(...dt.map((item) => item.value));
            let usedPartPercentages = dt.map((item) => {
              return {
                ...item,
                countPercentage: (item.value / maxUsedCount) * 100,
              };
            });
            const findItem = usedPartPercentages.find(
              (item) => item.name === "items"
            );
            const findService = usedPartPercentages.find(
              (item) => item.name === "services"
            );
            const findPackages = usedPartPercentages.find(
              (item) => item.name === "packages"
            );
            // partsMaintRequest
            this.setState({
              loader2: false,
              maintenanceRequestCount: res,
              partsMaintRequest: findItem,
              serviceMaintRequest: findService,
              packageMaintRequest: findPackages,
            });
  
            let dat ={
              maintenanceRequestCount:res,
              partsMaintRequest: findItem,
              serviceMaintRequest: findService,
              packageMaintRequest: findPackages,
              initFetch:true
            }
            this.props.dispatch(addTab2(dat)); 
          })
          .catch((err) => {
            console.log("err 5====", err);
          });

      }
    });

    this.setState({ loader10: true }, () => {
      if(this.props.tab13&&this.props.tab13.initFetch){
        this.setState({
          loader10: false,
          vehiclesCategories: this.props.tab13?.data||[],
        });
      }
      else{
        instance({ url: `/api/dashboards/cms/7?contractType=1&userType=3`, method: "GET" })
          .then((res) => {
            let dt = [];
            for (const [key, value] of Object.entries(res)) {
              dt.push({ name: key, value: value });
            }
            let maxUsedCount = Math.max(...dt.map((item) => item.value));
            let dtRes = dt.reverse();
            let usedPartPercentages = dtRes.map((item) => {
              return {
                ...item,
                countPercentage: (item.value / maxUsedCount) * 100,
              };
            });
            // partsMaintRequest
            this.setState({
              loader10: false,
              vehiclesCategories: usedPartPercentages,
            });
            let dat ={
              initFetch:true,
              data:usedPartPercentages
            }
            this.props.dispatch(addTab13(dat))
          })
          .catch((err) => {
            console.log("err 7====", err);
          });
        
      }
    });

    this.setState({ loader8: true }, () => {
      if(this.props.tab9 && this.props.tab9.initFetch){
         this.setState({ usedPart: this.props.tab9.data, loader8: false });
      }
      else{
        instance({ url: `/api/dashboards/cms/8?contractType=1&userType=3`, method: "GET" })
          .then((res) => {
            let maxUsedCount = Math.max(...res.map((item) => item.usedCount));
            let usedPartPercentages = res.map((item) => {
              return {
                ...item,
                usedCountPercentage: (item.usedCount / maxUsedCount) * 100,
              };
            });
            this.setState({ usedPart: usedPartPercentages, loader8: false });
            let dt = {
              data:usedPartPercentages,
              initFetch:true
            }
            this.props.dispatch(addTab9(dt))
          })
          .catch((err) => {
            console.log("err 8====", err);
          });
      }
    });

    this.setState({ loader13: true }, () => {
      if(this.props.tab10 && this.props.tab10.initFetch){
         this.setState({ usedService: this.props.tab10.data, loader13: false });
     }
     else{
       instance({ url: `/api/dashboards/cms/9?contractType=1&userType=3`, method: "GET" })
         .then((res) => {
           let maxUsedCount = Math.max(...res.map((item) => item.usedCount));
           let usedPartPercentages = res.map((item) => {
             return {
               ...item,
               usedCountPercentage: (item.usedCount / maxUsedCount) * 100,
             };
           });
 
           this.setState({ loader13: false, usedService: usedPartPercentages });
           let dt ={
             initFetch: true,
             data: usedPartPercentages
           }
           this.props.dispatch(addTab10(dt))
         })
         .catch((err) => {
           console.log("err 9====", err);
         });
     }
    });

    this.setState({ loader14: true }, () => {
      if(this.props.tab11 && this.props.tab11.initFetch){
        this.setState({ loader14: false, usedPackages: this.props.tab11.data });
      }
      else{
          instance({ url: `/api/dashboards/cms/10?contractType=1&userType=3`, method: "GET" })
          .then((res) => {
            let maxUsedCount = Math.max(...res.map((item) => item.usedCount));
            let usedPartPercentages = res.map((item) => {
              return {
                ...item,
                usedCountPercentage: (item.usedCount / maxUsedCount) * 100,
              };
            });
            this.setState({ loader14: false, usedPackages: usedPartPercentages });
            let dt = {
              initFetch:true,
              data:usedPartPercentages
            }
            this.props.dispatch(addTab11(dt))
          })
          .catch((err) => {
            console.log("err 10====", err);
          });
      }
    });

    this.setState({ loader3: true }, () => {
      if(this.props.tab3 && this.props.tab3.initFetch){
        let res = this.props.tab3.collectionsAndOutStanding
        let balancePercentage =
              res.totalOutstandingBalance > res.totalPaid
                ? (res.totalPaid / res.totalSaleNetAmount) * 100
                : (res.totalPaid / res.totalSaleNetAmount) * 100;
        this.setState({
          loader3: false,
          collectionsAndOutStanding: {
            ...this.props.tab3.collectionsAndOutStanding,
            balancePercentage: balancePercentage,
          },
        });
      }
      else{
        // instance({url: `/api/dashboards/cms/12?to=${to}&from=${from}`, method: "GET" })
        instance({url: `/api/dashboards/cms/12?contractType=1&userType=3`, method: "GET" })
          .then((res) => {
            let balancePercentage =
              res.totalOutstandingBalance > res.totalPaid
                ? (res.totalPaid / res.totalSaleNetAmount) * 100
                : (res.totalPaid / res.totalSaleNetAmount) * 100;
            this.setState({
              loader3: false,
              collectionsAndOutStanding: {
                ...res,
                balancePercentage: balancePercentage,
              },
            });
            let dt = {
              initFetch:true,
              collectionsAndOutStanding: {
                ...res,
                balancePercentage: balancePercentage,
              }
            }
            this.props.dispatch(addTab3(dt))
          })
          .catch((err) => {
            console.log("err 10====", err);
          });
      }
    });

// --------------------------------------------------------------------------  this.setState({ loader3: true }, () => {
  this.setState({ loader17: true }, () => {
    if(this.props.tab17 && this.props.tab17.initFetch){
       this.setState({
        loader17: false,
        topVehiles: this.props.tab17.data,
      });
    }
    else{
      instance({ url: `/api/dashboards/cms/17?contractType=1&userType=3`, method: "GET" })
        .then((res) => {
          this.setState ({
            loader17: false,
            topVehiles: res || [],
          });
          let dt= {
            data: res || [],
            initFetch:true
          }
          this.props.dispatch(addTab17(dt))
        })
        .catch((err) => {
          console.log("err15====", err);
        });
    }
  });
  this.setState({ loader19: true }, () => {
    if(this.props.tab19 && this.props.tab19.initFetch){
      const raw = this.props.tab19.data || {};
      this.setState({
        loader19: false,
        topMaintenancePerDay: raw.costPerDay || {},
        topMaintenancePerKm: raw.costPerKm || {},
      });
    }
    else{
      instance({ url: `/api/dashboards/cms/19?contractType=1&userType=3`, method: "GET" })
        .then((res) => {
          this.setState ({
            loader19: false,
            topMaintenancePerDay: res.costPerDay || {},
            topMaintenancePerKm: res.costPerKm || {}
          });
          let dt= {
            data: res || {},
            initFetch:true
          }
          this.props.dispatch(addTab19(dt))
        })
        .catch((err) => {
          console.log("err19====", err);
        });
    }
  });

// --------------------------------------------------------------------------  this.setState({ loader3: true }, () => {


    this.setState({ loader9: true }, () => {
      if(this.props.tab4 && this.props.tab4.initFetch){
         this.setState({
          loader9: false,
          salesDataYearly: this.props.tab4.salesDataYearly,
          allSaleData: this.props.tab4.allSaleData,
          salesDataMonthly: this.props.tab4.salesDataMonthly,
        });
      }
      else{
        instance({ url: `/api/dashboards/cms/13?contractType=1&userType=3`, method: "GET" })
          .then((res) => {
            let monthlyDt = [];
            let yealyDt = [];
            let colors = ["#28A745", "#EAEAEA"];
            let colors2 = ["#0288D1", "#EAEAEA"];
            let ind = 0;
            let ind2 = 0;
            for (const [key, value, index] of Object.entries(res)) {
              if (key === "monthlySale" || key === "monthlyTarget") {
                let  salePercentage =(res.monthlySale / res.monthlyTarget) * 100
                let salePrecentRes = salePercentage > 100 ? 100 : salePercentage

                monthlyDt.push({
                  name: key,
                  // y: value,
                  y: key === "monthlySale" ? salePrecentRes : 100 - salePrecentRes,

                  value: value,
                  formattedvalue: value,
                  color: colors[ind++],
                });
              } else {
         
                let  salePercentage =(res.yearlySale / res.yearlyTarget) * 100
                let salePrecentRes = salePercentage > 100 ? 100 : salePercentage
                
                yealyDt.push({
                  name: key,
                  y: key === "yearlySale" ? salePrecentRes : 100 - salePrecentRes,
                  value: value,
                  formattedvalue: value,
                  color: colors2[ind2++],
                });
              }
            }
            let makeDataMonthly = [{ data: monthlyDt }];
            let makeDataYearly = [{ data: yealyDt }];

            let yearlyList =  res.yearlyList || {}
            let monthlyList =  res.monthlyList || {}
            const formattedDataYearly = Object.keys(yearlyList).map((key) => ({
              name: key,
              y: yearlyList[key],
            }));
            const formattedDataMonthly= Object.keys(monthlyList).map((key) => ({
              name: key,
              y: monthlyList[key],
            }));
            // return formattedDataYearly;


            this.setState({
              loader9: false,
              salesDataYearly: formattedDataYearly,
              allSaleData: res,
              salesDataMonthly: formattedDataMonthly,
            });
            let dt= {
              salesDataYearly: formattedDataYearly,
              allSaleData: res,
              salesDataMonthly: formattedDataMonthly,
              initFetch:true
            }
            this.props.dispatch(addTab4(dt))
          })
          .catch((err) => {
            console.log("err 10====", err);
          });
      }
    });

   

    this.setState({ loader11: true }, () => {
      if(this.props.tab14 && this.props.tab14.initFetch){
         this.setState({
          loader11: false,
          totalProfitTab14: this.props.tab14.data,
        });
      }
      else{
        instance({ url: `/api/dashboards/cms/15?contractType=1&userType=3`, method: "GET" })
          .then((res) => {
            let maxUsedCount = Math.max(
              ...res.clientList.map((item) => item.profit)
            );
            let calculateProfitPercentage = res.clientList.map((item) => {
              return {
                ...item,
                countPercentage: (item.profit / maxUsedCount) * 100,
              };
            });
            this.setState({
              loader11: false,
              totalProfitTab14: calculateProfitPercentage,
            });
            let dt= {
              data: calculateProfitPercentage,
              initFetch:true
            }
            this.props.dispatch(addTab14(dt))
          })
          .catch((err) => {
            console.log("err15====", err);
          });
      }
    });





    this.setState({ loader18: true }, () => {
      if(this.props.tab18 && this.props.tab18.initFetch){
         this.setState({
          loader18: false,
          monthlySaleNetAmount: this.props.tab18.data,
        });
      }
      else{
        instance({ url: `/api/dashboards/cms/18?contractType=1&userType=3`, method: "GET" })
          .then((res) => {

            this.setState({
              loader18: false,
              monthlySaleNetAmount: res || {},
            });
            let dt= {
              data: res || {},
              initFetch:true
            }
            this.props.dispatch(addTab18(dt))
          })
          .catch((err) => {
            console.log("err15====", err);
          });
      }
    });
  };
  generateRandomColor = () => {
    let colors = [
      "#f38686",
      "#91e064",
      "#e86493",
      "#f6cc4e",
      "#d52f2f",
      "#5d2c2c",
      "#45e6aa",
      "#427ace",
      "#477ac7",
      "#c747b5",
    ];
    let randomColor = colors[Math.floor(Math.random() * colors.length)];
    return randomColor;
  };

  pickUniqueColor = () => {
    let colors = [
      "#f38686",
      "#91e064",
      "#e86493",
      "#f6cc4e",
      "#d52f2f",
      "#5d2c2c",
      "#45e6aa",
      "#427ace",
      "#477ac7",
      "#c747b5",
    ];

    const randomIndex = Math.floor(Math.random() * colors.length);
    const pickedColor = colors[randomIndex];
    colors.splice(randomIndex, 1);
    return pickedColor;
  };

  getCMS16 = (to, from, chk) => {
     this.setState({ loader12: true }, () => {
     if(this.props.tab15 && this.props.tab15.initFetch){

      this.setState({ cogs: this.props.tab15?.data ||[], loader12: false });
    }
    else{
       let url =
        to && from && chk
          ? `/api/dashboards/cms/16?to=${to}&from=${from}&contractType=1&userType=3`
          : `/api/dashboards/cms/16?contractType=1&userType=3`;
      instance({ url: url, method: "GET" })
        .then((res) => {
          let dt = [];
          for (const [key, value] of Object.entries(res)) {
            let name = key;
            dt.push({ ...value, name: name });
          }
          let maxUsedCount = Math.max(...dt.map((item) => item.invoicesCount));
           if(this.props.ServerSetting.attributes.c_garageTarget){
            let dtRes = dt.reverse();
            let types = this.props.ServerSetting.attributes.c_garageTarget
 
            let usedPartPercentages = dtRes.map((item) => { 
              let re = item.name
              let count = types[re]
    
              // let targetValue = item.target[item.name];
           // totalCost
              return {
                ...item,
                countPercentage: item.totalCost > count ? 100 : (item.totalCost / count) * 100,
                // countPercentage: item.invoicesCount > count ? 100 : (item.invoicesCount / count) * 100,
                // target:targetValue
                target: types[item.name] 
              };

          })
          //                 countPercentage: item.invoicesCount > count ? 100  : (item.invoicesCount / count) * 100,

          this.setState({ cogs: usedPartPercentages, loader12: false });
          let dat = {
            initFetch:true,
            data:usedPartPercentages
          }
          this.props.dispatch(addTab15(dat))
          }
        else{
          let maxUsedCount = Math.max(
            ...dt.map((item) => item.invoicesCount)
          );
          let dtRes = dt.reverse();

          let calculateProfitPercentage = dtRes.map((item) => {
            return {
              ...item,
              
              countPercentage: (item.invoicesCount / maxUsedCount) * 100,
            };
          });
          this.setState({ cogs: calculateProfitPercentage, loader12: false });

          let dat = {
            initFetch:true,
            data:calculateProfitPercentage
          }
          this.props.dispatch(addTab15(dat))
          
        }
          // });
        })
        .catch((err) => {})
      

      }
    });
  };

  getCMS1 = (to, from) => {
    this.setState({ loader5: true }, () => {
      instance({
        url: `/api/dashboards/cms/1?to=${to}&from=${from}&contractType=1&userType=3`,
        method: "GET",
      })
        .then((res) => {
          let makeData = [];
          let colors = [
            "#da5e5e",
            "#f50057",
            "#7b101b",
            "#00c179",
            "#d52f2f",
            "#ec1c91",
            "#28a788",
            "#3f52b5e6",
            "#594a86",
            "#864a73",
          ];

          res &&
            res.map((item, index) => {
              makeData.push({
                name: item.contractNumber,
                key: item.accessVehiclesCount,
                y: item.accessVehiclesCount,
                color: colors[index],
              });
            });
          // let makeData2 = [{data: makeData}];
          this.setState({
            clientVehiclesVehicleWise: makeData,
            loader5: false,
          });
        })
        .catch((err) => {});
    });
  };

  getCMS2 = (to, from) => {
    this.setState({ loader5: true }, () => {
      let url =
        to && from
          ? `/api/dashboards/cms/2?to=${to}&from=${from}&contractType=1&userType=3`
          : `/api/dashboards/cms/2?contractType=1&userType=3`;
       instance({ url: url, method: "GET" })
        .then((res) => {
          if (res?.data && Array.isArray(res.data)) {
              const maxUsedCount = Math.max(
                ...res.data.map((item) => Number(item.accessVehiclesCount) || 0),
                1,
              );
              const usedPartPercentages = res.data.map((item) => ({
                ...item,
                name: item.name || item.contractNumber || item.accountName,
                salesPercentage:
                  ((Number(item.accessVehiclesCount) || 0) / maxUsedCount) * 100,
              }));
              this.setState({
                totalFleetSize: res.totalFleetCount,
                clientVehiclesVehicleWise: usedPartPercentages,
                loader5: false,
              });
              this.props.dispatch(
                addTab6({
                  initFetch: true,
                  clientVehiclesVehicleWise: usedPartPercentages,
                  totalFleetSize: res.totalFleetCount,
                }),
              );
          } else {
            this.setState({ loader5: false });
          }
        })
        .catch((err) => {
          this.setState({ loader5: false });
        });
    });
  };

  getCMS3 = (to, from, chk) => {
    this.setState({ loader7: chk ? false : true, tab1loader1:chk ? true : false, }, () => {
      let url =
        to && from
          ? `/api/dashboards/cms/3?to=${to}&from=${from}&contractType=1&userType=3`
          : `/api/dashboards/cms/3?contractType=1&userType=3`;
      instance({ url: url, method: "GET" })
        .then((res) => {
          if (chk) {
            this.setState({
              maintRequestClientWiseTab1: res?.totalDeliveryNotesCount || 1,
              loader7: false,
              tab1loader1:false 
            });
          } else {
            let maxUsedCount = Math.max(
              ...res.clientList.map((item) => item.count)
            );
            let usedPartPercentages =
              res.clientList &&
              res.clientList.map((item) => {
                return {
                  ...item,
                  countPercentage: (item.count / maxUsedCount) * 100,
                };
              });

            this.setState({
              loader7: false,
              tab1loader1:false ,

              maintRequestClientWise: {
                clientList: usedPartPercentages,
                totalInvoicesCount: res?.totalInvoicesCount || 0,
              },
            });
            let dat = {
              initFetch:true,
              maintRequestClientWise: {
                clientList: usedPartPercentages,
                totalInvoicesCount: res?.totalInvoicesCount || 0,
              },
              maintRequestClientWiseTab1: res?.totalDeliveryNotesCount || 1,
            }
            // this.props.dispatch(addTab8(dat));
          }
        })
        .catch((err) => {
          console.log("err 3 ====", err);
        });
    });
  };

  getCMS4 = (to, from, tab1) => {
    this.setState({ loader4: tab1 ? false : true, tab1loader5:tab1 ? true :false }, () => {
      let url =
        to && from
          ? `/api/dashboards/cms/4?to=${to}&from=${from}&contractType=1&userType=3`
          : `/api/dashboards/cms/4?contractType=1&userType=3`;
      instance({ url: url, method: "GET" })
        .then((res) => {
          let maxUsedCount = Math.max(
            ...res.clientList.map((item) => item.saleNetAmount)
          );
          let usedPartPercentages = res.clientList.map((item) => {
            return {
              ...item,
              salesPercentage: (item.saleNetAmount / maxUsedCount) * 100,
            };
          });

          if (tab1) {
            this.setState({
              loader4: false,
              tab1loader5:false ,
              salesClientsTab1: res.totalSaleTotalAmount,
              salesClients1: {
                ...res,
                clientList: usedPartPercentages,
              },
            });
          } else {
            this.setState({
              tab1loader5:false ,

              salesClients: {
                ...res,
                clientList: usedPartPercentages,
              },
              loader4: false,
            });
          }
          let dat ={
            res:res,
            initFetch:true,
            
          }
          // this.props.dispatch(addTab5(dat)); 

        })
        .catch((err) => {});
    });
  };

  getCMS5 = (to, from, chk) => {
    this.setState({ loader6: chk ? false : true, tab1loader4:chk ? true : false, }, () => {
      let url =
        to && from
          ? `/api/dashboards/cms/5?to=${to}&from=${from}&contractType=1&userType=3`
          : `/api/dashboards/cms/5?contractType=1&userType=3`;
      instance({ url: url, method: "GET" })
        .then((res1) => {
          if (chk) {
            this.setState({
              totalOurDue: res1?.totalOurDue,
              loader6: false,
              tab1loader4:false
            });
          } else {
            let res = res1.clientList.reverse();
            
            // let maxUsedCount = Math.max(...res.clientList?.map(item => item.outstandingBalance));
            let maxUsedCount = Math.max(
              ...res?.map((item) => item.overDue)
              );
             // let usedPartPercentages = res.clientList.map(item => {
            //   return {  ...item, ourDuePercentage: (item.overDue / maxUsedCount) * 100
            //   }
            // })
             let usedPartPercentages = res?.map((item) => {
              return {
                ...item,
                ourDuePercentage:
                  (item.overDue / maxUsedCount) * 100,
              };
            });

            this.setState({
              salesClientsWise: {
                ...res,
                clientList: usedPartPercentages,
              },
              loader6: false,
              tab1loader4:false

            });
            let dt = {
              initFetch:true,
              salesClientsWise: {
                ...res,
                clientList: usedPartPercentages,
              },
              totalOurDue: res?.totalOurDue || 0,
            }
            // this.props.dispatch(addTab7(dt))
          }
        })
        .catch((err) => {
          console.log("err 5====", err);
        });
    });
  };

  getCMS6 = (to, from) => {
     this.setState({ loader2: true }, () => {
      this.setState({
        partsMaintRequest: 0,
        serviceMaintRequest: 0,
        packageMaintRequest: 0,
      });
      let url =
        to && from
          ? `/api/dashboards/cms/6?to=${to}&from=${from}&contractType=1&userType=3`
          : `/api/dashboards/cms/6?contractType=1&userType=3`;
      instance({ url: url, method: "GET" })
        .then((res) => {
          let dt = [];
          for (const [key, value] of Object.entries(res)) {
            dt.push({ name: key, value: value });
          }
          let maxUsedCount = Math.max(...dt.map((item) => item.value));
          let usedPartPercentages = dt.map((item) => {
            return {
              ...item,
              countPercentage: (item.value / maxUsedCount) * 100,
            };
          });
          const findItem = usedPartPercentages.find(
            (item) => item.name === "items"
          );
          const findService = usedPartPercentages.find(
            (item) => item.name === "services"
          );
          const findPackages = usedPartPercentages.find(
            (item) => item.name === "packages"
          );
          // partsMaintRequest
          this.setState({
            loader2: false,
            maintenanceRequestCount: res,
            partsMaintRequest: findItem,
            serviceMaintRequest: findService,
            packageMaintRequest: findPackages,
          });
          let dat ={
            maintenanceRequestCount:res,
            partsMaintRequest: findItem,
            serviceMaintRequest: findService,
            packageMaintRequest: findPackages,
          }
          this.props.dispatch(addTab2(dat));
        })
        .catch((err) => {
          console.log("err 5====", err);
        });
    });
  };

  getCMS7 = (to, from) => {
    this.setState({ loader10: true }, () => {
      let url =
        to && from
          ? `/api/dashboards/cms/7?to=${to}&from=${from}&contractType=1&userType=3`
          : `/api/dashboards/cms/7?contractType=1&userType=3`;
      instance({ url: url, method: "GET" })
        .then((res) => {
          let dt = [];
          for (const [key, value] of Object.entries(res)) {
            dt.push({ name: key, value: value });
          }
          let maxUsedCount = Math.max(...dt.map((item) => item.value));
          let dtRes = dt.reverse();
          let usedPartPercentages = dtRes.map((item) => {
            return {
              ...item,
              countPercentage: (item.value / maxUsedCount) * 100,
            };
          });

          // partsMaintRequest
          this.setState({
            vehiclesCategories: usedPartPercentages,
            loader10: false,
          });
          let dat ={
            initFetch:true,
            data:usedPartPercentages
          }
          this.props.dispatch(addTab13(dat))
        })
        .catch((err) => {
          console.log("err 7====", err);
        });
    });
  };

  getCMS8 = (to, from) => {
    this.setState({ loader8: true }, () => {
      let url =
        to && from
          ? `/api/dashboards/cms/8?to=${to}&from=${from}&contractType=1&userType=3`
          : `/api/dashboards/cms/8?contractType=1&userType=3`;
      instance({ url: url, method: "GET" })
        .then((res) => {
          let maxUsedCount = Math.max(...res.map((item) => item.usedCount));
          let usedPartPercentages = res.map((item) => {
            return {
              ...item,
              usedCountPercentage: (item.usedCount / maxUsedCount) * 100,
            };
          });
          this.setState({ usedPart: usedPartPercentages, loader8: false });
          let dt = {
            data:usedPartPercentages,
            initFetch:true
          }
          this.props.dispatch(addTab9(dt))
        })
        .catch((err) => {
          console.log("err 8====", err);
        });
    });
  };

  getCMS9 = (to, from) => {
    this.setState({ loader13: true }, () => {
      let url =
        to && from
          ? `/api/dashboards/cms/9?to=${to}&from=${from}&contractType=1&userType=3`
          : `/api/dashboards/cms/9?contractType=1&userType=3`;
      instance({ url: url, method: "GET" })
        .then((res) => {
          let maxUsedCount = Math.max(...res.map((item) => item.usedCount));
          let usedPartPercentages = res.map((item) => {
            return {
              ...item,
              usedCountPercentage: (item.usedCount / maxUsedCount) * 100,
            };
          });

          this.setState({ usedService: usedPartPercentages, loader13: false });
          let dt ={
            initFetch: true,
            data: usedPartPercentages
          }
          this.props.dispatch(addTab10(dt))
        })
        .catch((err) => {
          console.log("err 9====", err);
        });
    });
  };

  getCMS10 = (to, from) => {
    this.setState({ loader14: true }, () => {
      let url =
        to && from
          ? `/api/dashboards/cms/10?to=${to}&from=${from}&contractType=1&userType=3`
          : `/api/dashboards/cms/10?contractType=1&userType=3`;
      instance({ url: url, method: "GET" })
        .then((res) => {
          // let res = res1.clientList;
          let maxUsedCount = Math.max(...res?.map((item) => item.usedCount));
          let usedPartPercentages = res.map((item) => {
            return {
              ...item,
              usedCountPercentage: (item.usedCount / maxUsedCount) * 100,
            };
          });
          this.setState({ usedPackages: usedPartPercentages, loader14: false });
          let dt = {
            initFetch:true,
            data:usedPartPercentages
          }
          this.props.dispatch(addTab11(dt))
        })
        .catch((err) => {
          console.log("err 10====", err);
        });
    });
  };

  getCMSTab12 = (to, from) => {
    this.setState({ loader9: true }, () => {
      let url =
        to && from
          ? `/api/dashboards/cms/13?to=${to}&from=${from}&contractType=1&userType=3`
          : `/api/dashboards/cms/13?contractType=1&userType=3`;
      instance({ url: url, method: "GET" })
        .then((res) => {
          let yealyDt,
            monthlyDt = [];
          let colors = ["#28A745", "#EAEAEA"];
          let colors2 = ["#0288D1", "#EAEAEA"];
          let ind = 0;
          let ind2 = 0;
          for (const [key, value, index] of Object.entries(res)) {
            if (key === "monthlySale" || key === "monthlyTarget") {
              monthlyDt.push({
                name: key,
                y: value,
                value: value,
                formattedvalue: value,
                color: colors[ind++],
              });
            } else {
              yealyDt.push({
                name: key,
                y: value,
                value: value,
                formattedvalue: value,
                color: colors2[ind2++],
              });
            }
          }
          let makeDataMonthly = [{ data: monthlyDt }];
          let makeDataYearly = [{ data: yealyDt }];
          this.setState({
            salesDataYearly: makeDataYearly,
            loader9: false,
            allSaleData: res,
          });
          let dt= {
            salesDataYearly: makeDataYearly,
            allSaleData: res,
            initFetch:true
          }
          this.props.dispatch(addTab4(dt))
        })
        .catch((err) => {
          console.log("err 10====", err);
        });
    });
  };

  getCMS12 = (to, from) => {
    this.setState({ loader3: true }, () => {
      let url =
        to && from
          ? `/api/dashboards/cms/12?to=${to}&from=${from}&contractType=1&userType=3`
          : `/api/dashboards/cms/12?contractType=1&userType=3`;
      instance({ url: url, method: "GET" })
        .then((res) => {
          let maxUsedCount =
            res.totalOutstandingBalance > res.totalPaid
              ? res.totalOutstandingBalance
              : res.totalPaid;
          let balancePercentage =
            res.totalOutstandingBalance > res.totalPaid
              ? (res.totalPaid / res.totalSaleNetAmount) * 100
              : (res.totalPaid / res.totalSaleNetAmount) * 100;
          this.setState({
            loader3: false,
            collectionsAndOutStanding: {
              ...res,
              balancePercentage: balancePercentage,
            },
          });
        })
        .catch((err) => {
          console.log("err 10====", err);
        });
    });
  };

  getCMS13 = (to, from) => {
    this.setState({ loader: true }, () => {
      let url =
        to && from
          ? `/api/dashboards/cms/13?to=${to}&from=${from}&contractType=1&userType=3`
          : `/api/dashboards/cms/13?contractType=1&userType=3`;
      instance({ url: url, method: "GET" })
        .then((res) => {
          let dt = [];
          let colors = [
            "#28A745",
            "#e86493",
            "#EAEAEA",
            "#f6cc4e",
            "#d52f2f",
            "#5d2c2c",
            "#45e6aa",
            "#427ace",
            "#477ac7",
            "#c747b5",
          ];
          let ind = 0;
          for (const [key, value, index] of Object.entries(res)) {
            dt.push({
              name: key,
              y: value,
              value: value,
              formattedvalue: value,
              color: colors[ind++],
            });
          }

          let makeData = [{ data: dt }];

          this.setState({
            loader: false,
            salesData: makeData,
            allSaleData: res,
          });
        })
        .catch((err) => {});
    });
  };
  getCMS14 = (to, from) => {
    this.setState({ loader1: true , tab1loader2:true}, () => {
      let url =
        to && from
          ? `/api/dashboards/cms/14?to=${to}&from=${from}&contractType=1&userType=3`
          : `/api/dashboards/cms/14?contractType=1&userType=3`;
      instance({ url: url, method: "GET" })
        .then((res) => {
          this.setState({ totalAccounts: res, loader1: false , tab1loader2:false});
        })
        .catch((err) => {});
    });
  };
  getCMS15 = (to, from) => {
    this.setState({ loader11: true }, () => {
      let url =
        to && from
          ? `/api/dashboards/cms/15?to=${to}&from=${from}&contractType=1&userType=3`
          : `/api/dashboards/cms/15?contractType=1&userType=3`;
      instance({ url: url, method: "GET" })
        .then((res) => {
          let maxUsedCount = Math.max(
            ...res.clientList.map((item) => item.profit)
          );
          let calculateProfitPercentage = res.clientList.map((item) => {
            return {
              ...item,
              countPercentage: (item.profit / maxUsedCount) * 100,
            };
          });
          this.setState({
            totalProfitTab14: calculateProfitPercentage,
            loader11: false,
          });
          let dt= {
            data: calculateProfitPercentage,
            initFetch:true
          }
          this.props.dispatch(addTab14(dt))
        })
        .catch((err) => {
          console.log("err15====", err);
        });
    });
  };
  // getFMD1 = (to, from) => {
  //   this.setState({ loaderA1: true , tab1loader3:true}, () => {
  //     let url =
  //       to && from
  //         ? `/api/dashboards/fmd/1?to=${to}&from=${from}`
  //         : `/api/dashboards/fmd/1`;
  //     instance({ url: url, method: "GET" })
  //       .then((res) => {
  //         this.setState({ totalCost: res, loaderA1: false,  tab1loader3:false });
          
  //       })
  //       .catch((err) => {});
  //   });
  // };

  // getToFrom = (value) => {
  //   let timezone = ''
  //   if (
  //     this.props.logInUser &&
  //     this.props.logInUser.attributes &&
  //     this.props.logInUser.attributes.timezone
  //   ) {
  //     timezone = this.props.logInUser.attributes.timezone
  //   }
  //   moment.tz.setDefault(timezone)
    
   //   if (value === 1) {
  //     let value = new Date();
  //     let val = moment.utc(value).startOf("month");
  //     let to = val._i.toISOString();
  //     let from = val._d.toISOString();
  //     let valFrom = moment(from).startOf("month").startOf("start").utc().format("YYYY-MM-DDTHH:mm:59.59") + "Z";
  //     let res = {
  //       to: to,
  //       from: from,
  //     };
  //     return res;
  //   } else if (value === 2) {
  //     let date = new Date();
  //     let from = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth() - 1, 1)).toISOString();
  //     let fromVal = moment(from).startOf("month").startOf("start").utc().format("YYYY-MM-DDTHH:mm:00.00") + "Z";
  //     let date2 = new Date();
  //     let to = new Date(date2.getUTCFullYear(), date2.getUTCMonth(),1).toISOString();
  //     let chnTo = moment(to).endOf('day').utc().format("YYYY-MM-DDTHH:mm:59.59") + "Z"
     
  //     let res = {
  //       to: chnTo,
  //       from: fromVal,
  //     };
  //     return res;
  //   } else if (value === 3) {
  //     let today = new Date();
  //     let lastMonth = new Date();
  //     lastMonth.setMonth(today.getMonth() - 3);

  //     let from = new Date(
  //       lastMonth.getFullYear(),
  //       lastMonth.getUTCMonth() - 1,
  //       1
  //     );
  //     let to = new Date(today.getFullYear(), today.getMonth(), 0);
  //     let res = {
  //       to: to.toISOString(),
  //       from: from.toISOString(),
  //     };
  //     return res;
  //   } else if (value === 4) {
  //     let from = new Date(new Date().getFullYear(), 0, 1).toISOString();
  //     let to = new Date().toISOString();
  //     let res = {
  //       to: to,
  //       from: from,
  //     };
  //     return res;
  //   } else if (value === 6) {
  //     let res = {
  //       to: false,
  //       from: false,
  //     };
  //     return res;
  //   } else {
  //     let from = new Date(new Date().getFullYear() - 1, 0, 1).toISOString();
  //     let to = new Date(new Date().getFullYear() - 1, 11, 31).toISOString();
  //     let res = {
  //       to: to,
  //       from: from,
  //     };
  //     return res;
  //   }
  // };


  getToFrom = (value) => {
    let  timezone = "";
    if (
      this.props.logInUser &&
      this.props.logInUser.attributes &&
      this.props.logInUser.attributes.timezone
    ) {
      timezone = this.props.logInUser.attributes.timezone
    }else{
      timezone = "Asia/Riyadh"
    }
     
    const now = moment().tz(timezone);

    if (value === 1) {
      const startOfMonth = now.clone().startOf("month");
      const endOfMonth = now.clone().endOf("month");
  
      return {
        from: startOfMonth.toISOString(),
        to: endOfMonth.toISOString(),
      };
    } else if (value === 2) {
      const lastMonthStart = now.clone().subtract(1, "month").startOf("month");
      const lastMonthEnd = now.clone().subtract(1, "month").endOf("month");
  
      return {
        from: lastMonthStart.toISOString(),
        to: lastMonthEnd.toISOString(),
      };
    } else if (value === 3) {
      const threeMonthsAgo = now.clone().subtract(3, "months");
      const startOfThreeMonthsAgo = threeMonthsAgo.clone().startOf("month");
      const endOfLastMonth = now.clone().subtract(1, "month").endOf("month");
  
      return {
        from: startOfThreeMonthsAgo.toISOString(),
        to: endOfLastMonth.toISOString(),
      };
    } else if (value === 4) {
      const startOfYear = now.clone().startOf("year");
  
      return {
        from: startOfYear.toISOString(),
        to: now.toISOString(),
      };
    } else if (value === 6) {
      return {
        from: false,
        to: false,
      };
    } else {
      const lastYearStart = now.clone().subtract(1, "year").startOf("year");
      const lastYearEnd = now.clone().subtract(1, "year").endOf("year");
  
      return {
        from: lastYearStart.toISOString(),
        to: lastYearEnd.toISOString(),
      };
    }
  };


  handleChange = (name, e) => {
    if (name === "tab1") {
      this.setState({ loader1: true });
    }
    this.setState({ [name]: e.label }, async () => {
      const res = await this.getToFrom(e.value);
      if (name === "tab1") {
        await Promise.all([
          // this.getFMD1(res.to, res.from),                    // in tab5 total is showing form cms/4 api
          this.getCMS14(res.to, res.from),
          this.getCMS5(res.to, res.from, true),
          this.getCMS4(res.to, res.from, true),
          this.getCMS3(res.to, res.from, true),
        ]).then(() => {
          this.setState({ loader1: false });
        });
      } else if (name === "tab2") {
         this.getCMS6(res.to, res.from);
      } else if (name === "tab3") {
        this.getCMS12(res.to, res.from);
      } else if (name === "tab4") {
        this.getCMS13(res.to, res.from);
      } else if (name === "tab5") {
        this.getCMS4(res.to, res.from);
      } else if (name === "tab6") {
        this.getCMS2(res.to, res.from);
      } else if (name === "tab7") {
        this.getCMS5(res.to, res.from);
      } else if (name === "tab8") {
        this.getCMS3(res.to, res.from);
      } else if (name === "tab9") {
        this.getCMS8(res.to, res.from);
      } else if (name === "tab10") {
        this.getCMS9(res.to, res.from);
      } else if (name === "tab11") {
        this.getCMS10(res.to, res.from);
      } else if (name === "tab12") {
        this.getCMSTab12(res.to, res.from);
      } else if (name === "tab13") {
        this.getCMS7(res.to, res.from);
      } else if (name === "tab14") {
        this.getCMS15(res.to, res.from);
      } else if (name === "tab15") {

        this.getCMS16(res.to, res.from, true);
      } else {
        this.getCMS10(res.to, res.from);
      }
    });
  };

  openVehicle = (item) => {
    if (!item) return;
    const categoryCount = item.categoryCount || item.categoryCounts || {};
    const entries = Object.entries(categoryCount);
    if (!entries.length) return;

    let dt = [];
    let ind = 0;
    let colors = [
      "#28A745",
      "#e86493",
      "#f6cc4e",
      "#EAEAEA",
      "#d52f2f",
      "#5d2c2c",
      "#45e6aa",
      "#427ace",
      "#477ac7",
      "#c747b5",
    ];
    for (const [key, value] of entries) {
      dt.push({
        name: key,
        y: Number(value) || 0,
        value: Number(value) || 0,
        formattedvalue: value,
        color: colors[ind++ % colors.length],
      });
    }
    let selectedData = [{ data: dt }];
    this.setState({ openGraph: true, selectedVehicle: selectedData });
  };
  CloseGraph = () => {
    this.setState({ openGraph: false, selectedVehicle: {} });
  };

  render() {
    const { logInUsers } = this.props;
    const loginUserCurrency = logInUsers?.attributes?.currencyLabel || "SAR";
    const { packages, items, services } = this.state.maintenanceRequestCount || {};
    const pa = packages || 0;
    const it = items || 0;
    const se = services || 0;
    const totaMainReqCate = pa + it + se;

    const clientVehiclesVehicleWiseChart = {
      config: pieChartDefault().initializeWithOptions({
        chart: { height: "310px" },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: false,
              format: "{point.name}: {point.y:.1f}",
              style: { fontWeight: "bold", color: "currentColor" },
            },
          },
        },
        series: this.state.selectedVehicle,
        legend: { enabled: true },
        yAxis: { gridLineWidth: 0 },
        tooltip: {
          formatter: function () {
            return (
              "<strong>" +
              this.key +
              "</strong><br/><strong>" +
              this.y.toFixed(2) +
              "</strong>"
            );
          },
        },
      }),
      show: true,
    };
    const avgTicket =
      this.state?.salesClientsTab1 && this.state.maintRequestClientWiseTab1
        ? this.state.salesClientsTab1 / this.state.maintRequestClientWiseTab1
        : 0;

    const kpiLoading =
      this.state.tab1loader1 ||
      this.state.tab1loader2 ||
      this.state.tab1loader4 ||
      this.state.tab1loader5;

    return (
      <MaintenanceDashboardView
        translate={this.props.translate}
        loginUserCurrency={loginUserCurrency}
        kpiLoading={!!kpiLoading}
        totalSales={this.state.salesClients1?.totalSaleTotalAmount || 0}
        totalAccounts={parseInt(this.state?.totalAccounts?.totalAccounts) || 0}
        totalFleetSize={this.state.totalFleetSize || 0}
        maintRequestTotal={totaMainReqCate || 0}
        avgTicket={avgTicket}
        overdue={this.state.totalOurDue || 0}
        monthlySale={this.state.allSaleData?.monthlySale || 0}
        monthlyTarget={this.state.allSaleData?.monthlyTarget || 0}
        tab1={this.state.tab1}
        onTabChange={this.handleChange}
        unitLoading={!!this.state.loader2}
        parts={it}
        services={se}
        packages={pa}
        partsPct={this.state.partsMaintRequest?.countPercentage || 0}
        servicesPct={this.state.serviceMaintRequest?.countPercentage || 0}
        packagesPct={this.state.packageMaintRequest?.countPercentage || 0}
        tab2={this.state.tab2}
        collectionsLoading={!!this.state.loader3}
        collectionsData={this.state.collectionsAndOutStanding}
        tab3={this.state.tab3}
        allSaleData={this.state.allSaleData}
        monthlyTargetLoading={!this.state.allSaleData}
        yearlyTargetLoading={!!this.state.loader9}
        salesClientsLoading={!!this.state.loader4}
        salesClients={this.state.salesClients}
        tab5={this.state.tab5}
        fleetLoading={!!this.state.loader5}
        fleetRows={this.state.clientVehiclesVehicleWise || []}
        openGraph={!!this.state.openGraph}
        fleetChartOptions={clientVehiclesVehicleWiseChart.config}
        onFleetRowClick={this.openVehicle}
        onFleetBack={this.CloseGraph}
        overdueClientsLoading={!!this.state.loader6}
        overdueClients={this.state.salesClientsWise}
        tab7={this.state.tab7}
        jobCardsLoading={!!this.state.loader7}
        jobCards={this.state.maintRequestClientWise}
        tab8={this.state.tab8}
        partsLoading={!!this.state.loader8}
        usedParts={Array.isArray(this.state.usedPart) ? this.state.usedPart : []}
        tab9={this.state.tab9}
        servicesLoading={!!this.state.loader13}
        usedServices={Array.isArray(this.state.usedService) ? this.state.usedService : []}
        tab10={this.state.tab10}
        packagesLoading={!!this.state.loader14}
        usedPackages={Array.isArray(this.state.usedPackages) ? this.state.usedPackages : []}
        tab11={this.state.tab11}
        vehicleCatsLoading={!!this.state.loader10}
        vehicleCategories={this.state.vehiclesCategories || []}
        tab13={this.state.tab13}
        profitLoading={!!this.state.loader11}
        profitRows={this.state.totalProfitTab14 || []}
        tab14={this.state.tab14}
        stationsLoading={!!this.state.loader12}
        stations={this.state.cogs || []}
        tab15={this.state.tab15}
        monthlyNetLoading={!!this.state.loader18}
        monthlySaleNetAmount={this.state.monthlySaleNetAmount || {}}
        vehiclesLoading={!!this.state.loader17 || !!this.state.loader19}
        topVehicles={this.state.topVehiles || []}
        topPerDay={this.state.topMaintenancePerDay || {}}
        topPerKm={this.state.topMaintenancePerKm || {}}
      />
    );
  }
}
const mapState = (state,props) => { 
  return {
    // currentId: props.match?.params?.id,
    logInUsers: state.logInUsers,
    themecolors: state.themecolors,
    tab1: state.tab1,
    tab2: state.tab2,
    tab3: state.tab3,
    tab4: state.tab4,
    tab5: state.tab5,
    tab6: state.tab6,
    tab7: state.tab7,
    tab8: state.tab8,
    tab9: state.tab9,
    tab10: state.tab10,
    tab11: state.tab11,
    tab12: state.tab12,
    tab13: state.tab13,
    tab14: state.tab14,
    tab15: state.tab15,
    tab18:state.tab18,
    tab17:state.tab17,
    tab19:state.tab19
  };
};
const mapStateToProps = connect(mapState);
export const MaintenanceDashboard = mapStateToProps(withRoutes(MaintenanceDashbd));


